// import { v4 as uuidv4 } from "uuid";
import Bg1 from "../../assets/img/home1/Manufacturing/forging.webp";
import Bg2 from "../../assets/img/home1/Manufacturing/cnc.webp";
import Bg3 from "../../assets/img/home1/Manufacturing/grinding.webp";
import Bg4 from "../../assets/img/home1/Manufacturing/fasteners.webp";
import Bg5 from "../../assets/img/home1/Manufacturing/sheetMetal.webp";
import Bg6 from "../../assets/img/home1/Manufacturing/welding.webp";
import Bg7 from "../../assets/img/home1/Manufacturing/surfaceTreatment.webp";
import Bg8 from "../../assets/img/home1/Manufacturing/aluminiumExtrusion.webp";
import Bg9 from "../../assets/img/home1/Manufacturing/heatTreatment.webp";
import Bg10 from "../../assets/img/home1/Manufacturing/plasticRubber.webp";
import Icon1 from "../../assets/img/home1/Manufacturing-Icons/forging.png";
import Icon2 from "../../assets/img/home1/Manufacturing-Icons/cnc-machining.png";
import Icon3 from "../../assets/img/home1/Manufacturing-Icons/grinding_1.png";
import Icon4 from "../../assets/img/home1/Manufacturing-Icons/fasteners-manufacturing.png";
import Icon5 from "../../assets/img/home1/Manufacturing-Icons/sheet-metal-and-laser-cutting.png";
import Icon6 from "../../assets/img/home1/Manufacturing-Icons/welding-and-fabrication_1.png";
import Icon7 from "../../assets/img/home1/Manufacturing-Icons/surface-treatment-and-plating.png";
import Icon8 from "../../assets/img/home1/Manufacturing-Icons/aluminium-extrusion.png";
import Icon9 from "../../assets/img/home1/Manufacturing-Icons/heat-treatment_1.png";
import Icon10 from "../../assets/img/home1/Manufacturing-Icons/plastic-and-rubber-moulding_1.png";
const servicesOneData = [
  {
    // id: uuidv4(),
    bgImg: Bg1,
    icon: Icon1,
    heading: "Forging – Cold, Hot, Warm",
    btnText: "Learn More",
    slug: "forging-cold-hot-warm",
  },
  {
    // id: uuidv4(),
    bgImg: Bg2,
    icon: Icon2,
    heading: "CNC Machining – CNC, VMC, HMC",
    btnText: "Learn More",
    slug: "cnc-machining-cnc-vmc-hmc",
  },
  {
    // id: uuidv4(),
    bgImg: Bg3,
    icon: Icon3,
    heading: "Grinding – Cylindrical, Surface",
    btnText: "Learn More",
    slug: "grinding-cylindrical-surface",
  },
  {
    // id: uuidv4(),
    bgImg: Bg4,
    icon: Icon4,
    heading: "Fasteners Manufacturing",
    btnText: "Learn More",
    slug: "fasteners-manufacturing",
  },
  {
    // id: uuidv4(),
    bgImg: Bg5,
    icon: Icon5,
    heading: "Sheet Metal & Laser Cutting",
    btnText: "Learn More",
    slug: "sheet-metal-laser-cutting",
  },
  {
    // id: uuidv4(),
    bgImg: Bg6,
    icon: Icon6,
    heading: "Welding & Fabrication",
    btnText: "Learn More",
    slug: "welding-fabrication",
  },
  {
    // id: uuidv4(),
    bgImg: Bg7,
    icon: Icon7,
    heading: "Surface Treatment & Plating",
    btnText: "Learn More",
    slug: "surface-treatment-plating",
  },
  {
    // id: uuidv4(),
    bgImg: Bg8,
    icon: Icon8,
    heading: "Aluminium Extrusion",
    btnText: "Learn More",
    slug: "aluminium-extrusion",
  },
  {
    // id: uuidv4(),
    bgImg: Bg9,
    icon: Icon9,
    heading: "Heat Treatment",
    btnText: "Learn More",
    slug: "heat-treatment",
  },
  {
    // id: uuidv4(),
    bgImg: Bg10,
    icon: Icon10,
    heading: "Plastic & Rubber Moulding",
    btnText: "Learn More",
    slug: "plastic-rubber-moulding",
  },
];

export default servicesOneData;
